var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.showGrid
    ? _c(
        "div",
        {
          class: [
            "grid-container",
            "simple-grid",
            {
              "empty-grid": _vm.itemsData.length === 0,
              "is-portal": _vm.isPortalUser,
              "is-in-tab": _vm.isInTab,
            },
          ],
        },
        [
          _c("AlertComponent", {
            attrs: {
              whereIsRendered: _vm.componentWhereIsRenderedAlertComponent,
            },
          }),
          _vm.showHeaderTitle
            ? _c(
                "header",
                { staticClass: "simple-grid-header" },
                [
                  _c("span", { class: [_vm.headerIcon, "icon"] }),
                  _vm._t("header-title"),
                  _c("v-spacer"),
                  _vm.showHeaderButtons
                    ? _c("div", { staticClass: "buttons-container" }, [
                        _c(
                          "div",
                          { staticClass: "add-new" },
                          [
                            _c("button", {
                              class: [_vm.icons.print, "add-new-button"],
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.exportToPDF.apply(null, arguments)
                                },
                              },
                            }),
                            _c("button", {
                              class: [_vm.icons.export, "add-new-button"],
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.excelExport.apply(null, arguments)
                                },
                              },
                            }),
                            _vm.canSave
                              ? [
                                  _vm.clickOnlyOnceProp
                                    ? _c("button", {
                                        class: [
                                          _vm.icons.addNew,
                                          "add-new-button",
                                          { disabled: _vm.disabledNewButton },
                                        ],
                                        on: {
                                          "~click": function ($event) {
                                            return _vm.executeAction.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      })
                                    : _c("button", {
                                        class: [
                                          _vm.icons.addNew,
                                          "add-new-button",
                                          { disabled: _vm.disabledNewButton },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.executeAction.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      }),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          _vm.showButtons
            ? _c("div", { staticClass: "buttons-container" }, [
                _c("div", { staticClass: "add-new" }, [
                  _c("button", {
                    class: [_vm.icons.print, "add-new-button"],
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.exportToPDF.apply(null, arguments)
                      },
                    },
                  }),
                  _c("button", {
                    class: [_vm.icons.export, "add-new-button"],
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.excelExport.apply(null, arguments)
                      },
                    },
                  }),
                  _vm.canSave
                    ? _c("button", {
                        class: [_vm.icons.addNew, "add-new-button"],
                        on: {
                          click: function ($event) {
                            $event.stopPropagation()
                            return _vm.executeAction.apply(null, arguments)
                          },
                        },
                      })
                    : _vm._e(),
                ]),
              ])
            : _c("div", [_vm._t("buttons")], 2),
          _c(
            "ejs-grid",
            _vm._b(
              {
                ref: "grid",
                class: [
                  "grid-table",
                  !_vm.allowSelection ? "grid-not-selection" : "",
                ],
                attrs: {
                  detailTemplate: _vm.showPartialbankdraftDetail
                    ? _vm.partialbankdraftTemplate
                    : null,
                },
              },
              "ejs-grid",
              _vm.gridProps,
              false
            ),
            [
              _c(
                "e-columns",
                _vm._l(_vm.parsedColumns, function (column, index) {
                  return _c("e-column", {
                    key: `column-${index}`,
                    attrs: {
                      allowFiltering: !column.hideFilter,
                      customAttributes: _vm.getCustomAttributes(
                        column.customAttributes
                      ),
                      field: column.field,
                      filter: _vm.parsedFilter(column),
                      format: column.format,
                      headerTemplate: column.headerTemplate,
                      headerText: column.headerText,
                      headerTextAlign: column.headerTextAlign,
                      isPrimaryKey: column.isPrimaryKey ? true : false,
                      minWidth: column.minWidth,
                      template: _vm.getTemplate(column.templateName),
                      textAlign: column.textAlign,
                      type: column.type,
                      visible: column.visible,
                      width: column.width,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c("ejs-contextmenu", {
            ref: "contextMenuComponent",
            staticClass: "context-menu-component",
            attrs: {
              id: "contextMenuComponent",
              items: _vm.renderedContextMenuItems,
              select: _vm.contextMenuClickedItem,
              beforeOpen: _vm.onContextMenuBeforeOpen,
            },
          }),
          _c("OpenFileComponent", { ref: "openFileComponent" }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }